import { Box, Stack, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { format, formatDistance } from "date-fns";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ExportChecksum } from "./AircraftLastUpdated";

export const AircraftLastUpdatedPresenter: React.FC<{
  exportChecksums: ExportChecksum[];
}> = ({ exportChecksums }) => {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: "table_name",
      headerName: t('screens.superAdmin.uberAdmin.aircraftLastUpdated.columns.tableName'),
      width: 200,
      editable: false,
      sortable: false,
    },
    {
      field: "checksum",
      headerName: t('screens.superAdmin.uberAdmin.aircraftLastUpdated.columns.checksum'),
      width: 300,
      editable: false,
      sortable: false,
    },
    {
      field: "last_updated",
      headerName: t('screens.superAdmin.uberAdmin.aircraftLastUpdated.columns.lastUpdated'),
      width: 250,
      editable: false,
      sortable: false,
      valueGetter: (_, row) => {
        if (!row.last_updated) {
          return t('screens.superAdmin.uberAdmin.aircraftLastUpdated.notAvailable');
        }
        return format(
          new Date(row.last_updated),
          "yyyy-MM-dd hh:mm:ss a z"
        );
      },
    },
    {
      field: "last_updated_relative",
      headerName: "",
      width: 200,
      editable: false,
      sortable: false,
      valueGetter: (_, row) => {
        if (!row.last_updated) {
          return t('screens.superAdmin.uberAdmin.aircraftLastUpdated.notAvailable');
        }
        return formatDistance(new Date(row.last_updated), new Date(), {
          addSuffix: true,
        });
      },
    },
  ];
  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{ height: "250px", width: "100%" }}
    >
      <Box>
        <Typography variant="subtitle2">{t('screens.superAdmin.uberAdmin.aircraftLastUpdated.title')}</Typography>
        <Typography variant="body2" color="textSecondary">
          {t('screens.superAdmin.uberAdmin.aircraftLastUpdated.description')}
        </Typography>
      </Box>
      <DataGrid
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        disableRowSelectionOnClick
        hideFooterPagination
        getRowId={(row) => row.table_name}
        rows={exportChecksums}
        columns={columns}
      />
    </Stack>
  );
};
